module.exports = __webpack_public_path__ + "img/99c6301.jpeg";